import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getSiteList from "../http/getSiteList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteList = () => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const searchParams = new URLSearchParams(window.location.search);
  const testOrgId: string | null = searchParams.get("testOrgId");

  const fetchSites = useQuery(
    ["sites"],
    async () => {
      return getSiteList(
        await getAuthTokenBlocking(getToken, relogin),
        await getUserOrgId(getClaim, testOrgId ?? undefined)
      );
    },
    {
      // Allow query to be mounted multiple times on the same page without re-fetching
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    siteList: fetchSites.data?.sites,
    siteListQuery: fetchSites,
    fetchSites,
  };
};

export default useSiteList;
